module.exports = __webpack_public_path__ + "img/info-rocket-ill.883541f5.png";